import React from "react"
import { Box } from "@chakra-ui/react"

export default function BetaBanner() {
  const isBeta =
    typeof window !== "undefined" &&
    window.location.hostname.startsWith("beta.")

  if (!isBeta) return null

  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bg="yellow.300"
      color="black"
      p={4}
      textAlign="center"
      fontWeight="medium"
    >
      📢 Announcing Blind Insight V1! Head on over to{" "}
      <a
        href="https://app.blindinsight.io"
        style={{ textDecoration: "underline" }}
      >
        https://app.blindinsight.io
      </a>{" "}
      - your data and account information have already been linked!
    </Box>
  )
}
